export const officeTaskCreateModalTypes = {
    OPEN: "OFFICE_TASK_CREATE_MODAL_OPEN",
    CLOSE: "OFFICE_TASK_CREATE_MODAL_CLOSE",
};

export const openOfficeTaskCreateModal = ({
    officeId,
    source = "",
    sourceTitle = "",
    prefill = {},
} = {}) => ({
    type: officeTaskCreateModalTypes.OPEN,
    payload: {
        officeId: officeId || "",
        source,
        sourceTitle,
        prefill: prefill || {},
        openedAt: Date.now(),
    },
});

export const closeOfficeTaskCreateModal = () => ({
    type: officeTaskCreateModalTypes.CLOSE,
});
